// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-dialog-content { width: 320px; }
.progress {
   height: 3px;
   margin-top: 1em;
}
::ng-deep .mat-button:hover .mat-button-focus-overlay{
   opacity: 0.04 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/download-zip/download-zip.component.css"],"names":[],"mappings":"AAAA,sBAAsB,YAAY,EAAE;AACpC;GACG,WAAW;GACX,eAAe;AAClB;AACA;GACG,wBAAwB;AAC3B","sourcesContent":[".mat-dialog-content { width: 320px; }\n.progress {\n   height: 3px;\n   margin-top: 1em;\n}\n::ng-deep .mat-button:hover .mat-button-focus-overlay{\n   opacity: 0.04 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
